import React from 'react';
import Box from '../Box';
import Placeholder from '../Placeholder';
import ShoppableOutfitBase from './ShoppableOutfitBase';
import styles from './shoppableOutfitPlaceholder.module.scss';

type ShoppableOutfitPlaceholderProps = {
  /**
   * The aspect ratio
   *
   * @default 1.0
   */
  aspectRatio?: number;
};

/**
 * Extension of `Placeholder`, intended as a stand-in for a `ShoppableOutfit` while data is loading.
 *
 * Accepts an `aspectRatio` prop to replicate the layout of the `ShoppableOutfit` and avoid page shifts.
 */
const ShoppableOutfitPlaceholder = ({
  aspectRatio,
}: ShoppableOutfitPlaceholderProps) => (
  <ShoppableOutfitBase aspectRatio={aspectRatio}>
    <Box className={styles.placeholder}>
      <Placeholder variant="rect" width="100%" height="100%" />
    </Box>
  </ShoppableOutfitBase>
);

export default ShoppableOutfitPlaceholder;
